export class MaplibreObject {
    #type;
    #id;
    get type() {
        return this.#type;
    }
    get id() {
        return this.#id;
    }
    constructor(type, id) {
        this.#type = type;
        this.#id = id;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJvYmplY3RzL2Jhc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFnQixjQUFjO0lBQ25DLEtBQUssQ0FBTTtJQUNYLEdBQUcsQ0FBUTtJQUVYLElBQUksSUFBSTtRQUNQLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQTtJQUNsQixDQUFDO0lBQ0QsSUFBSSxFQUFFO1FBQ0wsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFBO0lBQ2hCLENBQUM7SUFFRCxZQUFZLElBQVUsRUFBRSxFQUFVO1FBQ2pDLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFBO1FBQ2pCLElBQUksQ0FBQyxHQUFHLEdBQUcsRUFBRSxDQUFBO0lBQ2QsQ0FBQztDQUNEIn0=